import { TPlayerLayoutStylesSchema } from './PlayerLayout.styles';

const styles: Partial<TPlayerLayoutStylesSchema> = {
  row: {
    mx: '5px',
    pb: '2',
    borderColor: 'blackAlpha.400',
    borderBottomWidth: '1px',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    _last: {
      border: 'none',
      boxShadow: 'none',
    },
  },
};
export default styles;
